// InfoIcon.jsx
import React, { useState } from "react";
import {
    Box,
    IconButton,
    Modal,
    Paper,
    Tooltip,
    Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const InfoIcon = ({
    title,
    description,
    children,
    enableModal = true,
    placement = "top-end",
    modalPadding = 5,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const hasInfo = Boolean(description || children);

    if (!title && !hasInfo) return null;

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    pt: title ? 2 : 0,
                }}
            >
                {title && <Typography fontWeight="bold">{title}</Typography>}

                {hasInfo && (
                    <Tooltip
                        title={description || ""}
                        placement={placement}
                        arrow
                        slotProps={{
                            tooltip: {
                                sx: {
                                    whiteSpace: "pre-line",
                                },
                            },
                            popper: {
                                modifiers: [
                                    {
                                        name: "offset",
                                        options: {
                                            offset: [0, -8],
                                        },
                                    },
                                ],
                            },
                        }}
                    >
                        <Box
                            component={enableModal ? IconButton : "span"}
                            onClick={
                                enableModal
                                    ? () => setIsModalOpen(true)
                                    : undefined
                            }
                            tabIndex={0}
                            role={enableModal ? undefined : "img"}
                            aria-label={
                                enableModal
                                    ? "Abrir información"
                                    : "Información"
                            }
                            sx={{
                                display: "inline-flex",
                                p: 0,
                                color: "text.secondary",
                                cursor: enableModal ? "pointer" : "help",
                            }}
                        >
                            <InfoOutlinedIcon fontSize="small" />
                        </Box>
                    </Tooltip>
                )}
            </Box>

            {enableModal && hasInfo && (
                <Modal
                    open={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    aria-label="Información adicional"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Paper
                        sx={{
                            p: modalPadding,
                            width: {
                                xs: "calc(100% - 32px)",
                                sm: 600,
                                md: 800,
                                lg: 1000,
                            },
                            maxWidth: "calc(100% - 32px)",
                            maxHeight: "calc(100vh - 32px)",
                            overflow: "auto",
                        }}
                    >
                        {title && (
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                sx={{ mb: 2 }}
                            >
                                {title}
                            </Typography>
                        )}

                        <Box sx={{ whiteSpace: "pre-wrap" }}>
                            {children ?? description}
                        </Box>
                    </Paper>
                </Modal>
            )}
        </>
    );
};

export default InfoIcon;
